import * as defaultImport from "@splunk/visualizations/Sankey";
export * from "@splunk/visualizations/Sankey";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
